/** 工作台 */
export default {
    dataOverview: "Data overview", // 数据总览
    queryBasicData: "Query basic data", // 查询基础数据
    dataQuery: "data query", // 数据查询
    dataOutput: "Data output", // 数据导出
    dataImportAndExport: "Passenger flow data import, query and export", // 客流数据导入与导出
    entranceAndExitDataQuery: "Entrance and exit passenger flow query", // 出入口客流数据查询
    dataCorrection: "data correction", // 数据修正
    customerPortrait: "customer portrait", // 客户画像
    faceRecognitionOfMenAndWomen: "Face recognition of men and women and customer age analysis", // 人脸识别男女和顾客年龄分析
    operationGuide: "Operation Guide", // 操作指南
    systemOperationFlowchart: "System Operation Flowchart", // 系统操作流程图
    afterSalesService: "After-sales service", // 售后服务
    AfterSalesQA: "After-sales Q&A", // 售后答疑解惑
    operationSystemHeadquartersBranches: "Operation system of headquarters and branches", // 总分馆运营系统
    libraryCustomDataLargeScreenCase: "Library custom data large screen case", // 图书馆定制数据大屏案例
    passengerFlowSystemHeadquartersBranches: "Passenger Flow System of Headquarters and Branches", // 总分馆客流系统
    generalCustomDataLargeScreenCase: "General custom data large screen case", // 通用定制数据大屏案例
    realTimePassengerFlowScreen: "Real-time passenger flow large screen", // 实时客流大屏
    realTimePassengerFlowScreenSubTitle: "Real-time dynamic data large screen case", // 实时动态数据大屏案例
    simpleCarryingCapacityScreen: "Simple carrying capacity data big screen", // 简单承载量数据大屏
    simpleCarryingCapacityScreenSubTitle: "Case study of customized data large screen for scenic area carrying capacity", // 景区承载量定制数据大屏案例
    VRTemplateDataScreen: "VR template data big screen", // VR模板数据大屏
    VRTemplateDataScreenSubTitle: "Customized data large screen case of VR exhibition hall", // VR展馆定制数据大屏案例
    // ----------------------------------------------------------------内页部分
    passengerFlowAnalysis: "passenger-flow analysis", // 客流分析
    passengerFlowPerson: "passenger flow (person)", // 客流(人)
    time: "time", // 时间
    entityOverview: "store overview", // 实体概览
    toDayPassengerFlow: "today passenger flow", // 今日客流
    yesterdayPassengerFlow: "yesterday passenger flow", // 昨日客流
    sametimeLastWeek: "Same time last week", // 上周同期
    growthAmplitude: "Growth amplitude", // 增长幅
    passengerFlowThisWeek: "Passenger flow this week", // 本周客流
    passengerFlowLastWeek: "Passenger flow last week", // 上周客流
    passengerFlowThisMonth: "Passenger flow this month", // 本月客流
    passengerFlowThisYear: "Passenger flow this year", // 本年客流
    lastMonth: "last month", // 上月客流
    date: "date", // 日期
    entityPassengerFlow: "Entity passenger flow (only query the top 30)", // 图标分析(最多查询前20条)
    detailList: "Detail list", // 详情列表
    queryCondition: "query condition", // 查询条件
    target: "target", // 指标
    entryNumber: "walk into", // 进人数 walk into
    exitNumber: "walk out", // 出人数 walk out
    passingsNumber: "walk pass", // 经过人数 walk pass
    strand: "strand", // 滞留人数
    groupType: "group type", // 汇总类型
    entityGroup: "group by store", // 按实体汇总
    organizationGroup: "group by organization", // 按组织架构汇总
    fiveMinute: "five minute", // 五分钟
    halfHour: "half hour", // 半小时
    hour: "hour", // 小时
    day: "day", // 天
    week: "week", // 周
    month: "month", // 月
    year: "year", // 年
    dimension: "dimension", // 维度
    temporalInterval: "temporal interval", // 时间区间
}